import React from "react";
import dayjs, { Dayjs } from "dayjs";
import DatePicker from "ui/molecules/DatePicker";
import Select from "ui/molecules/Select";
import TextField from "ui/atoms/TextField";
import { Business, ContractType, Job } from "types";

interface CompanyProps {
  jobs: Array<Job>;
  values: any;
  index: number;
  errors: any;
  touched: any;
  disabled?: boolean;
  handleChange: Function;
  businesses: Array<Business>;
  contractTypes: Array<ContractType>;
  setFieldValue: Function;
}

const Company = ({
  index,
  values,
  errors,
  touched,
  disabled,
  jobs = [],
  handleChange,
  businesses = [],
  contractTypes = [],
  setFieldValue,
}: CompanyProps) => {
  return (
    <div>
      <Select
        label='Empresa'
        margin='normal'
        disabled={disabled}
        mapKey='businessUnitId'
        mapValue='businessUnitName'
        name={`contracts.${index}.businessUnitId`}
        value={values?.contracts?.[index]?.businessUnitId}
        onChange={(selectedOption: React.ChangeEvent<HTMLInputElement>) => {
          handleChange(selectedOption);
        }}
        dataSource={businesses ?? []}
        error={touched?.contracts?.[index]?.businessUnitId && Boolean(errors?.contracts?.[index]?.businessUnitId)}
        helperText={touched?.contracts?.[index]?.businessUnitId && errors?.contracts?.[index]?.businessUnitId}
      />
      <Select
        label='Cargo'
        margin='normal'
        mapKey='jobId'
        disabled={disabled}
        mapValue='jobTitle'
        name={`contracts.${index}.jobId`}
        value={values?.contracts?.[index]?.jobId}
        onChange={(selectedOption: React.ChangeEvent<HTMLInputElement>) => {
          handleChange(selectedOption);
        }}
        dataSource={jobs ?? []}
        error={touched?.contracts?.[index]?.jobId && Boolean(errors?.contracts?.[index]?.jobId)}
        helperText={touched?.contracts?.[index]?.jobId && errors?.contracts?.[index]?.jobId}
      />
      <Select
        label='Contrato'
        margin='normal'
        disabled={disabled}
        mapKey='contractTypeId'
        mapValue='contractName'
        name={`contracts.${index}.contractTypeId`}
        value={values?.contracts?.[index]?.contractTypeId}
        onChange={(selectedOption: React.ChangeEvent<HTMLInputElement>) => {
          handleChange(selectedOption);
        }}
        dataSource={contractTypes ?? []}
        error={touched?.contracts?.[index]?.contractTypeId && Boolean(errors?.contracts?.[index]?.contractTypeId)}
        helperText={touched?.contracts?.[index]?.contractTypeId && errors?.contracts?.[index]?.contractTypeId}
      />
      <TextField
        margin='normal'
        disabled={disabled}
        id='temporaryCompany'
        label='Empresa Temporal'
        onChange={handleChange}
        maxLength={100}
        name={`contracts.${index}.temporaryCompany`}
        value={values?.contracts?.[index]?.temporaryCompany}
        error={touched?.contracts?.[index]?.temporaryCompany && Boolean(errors?.contracts?.[index]?.temporaryCompany)}
        helperText={touched?.contracts?.[index]?.temporaryCompany && errors?.contracts?.[index]?.temporaryCompany}
      />
      <DatePicker
        disabled={disabled}
        label='Fecha de Ingreso'
        name={`contracts.${index}.contractStartDate`}
        value={values?.contracts?.[index]?.contractStartDate}
        onChange={(value: Dayjs | null) => {
          if (dayjs(value).format("YYYY-MM-DD") === "Invalid Date") {
            setFieldValue(`contracts.${index}.contractStartDate`, null);
            return;
          }
          setFieldValue(`contracts.${index}.contractStartDate`, dayjs(value).format("YYYY-MM-DD"));
        }}
        error={touched?.contracts?.[index]?.contractStartDate && Boolean(errors?.contracts?.[index]?.contractStartDate)}
        helperText={touched?.contracts?.[index]?.contractStartDate && errors?.contracts?.[index]?.contractStartDate}
      />
      <DatePicker
        disabled={disabled}
        label='Fecha de Retiro'
        name={`contracts.${index}.contractEndDate`}
        value={values?.contracts?.[index]?.contractEndDate}
        onChange={(value: Dayjs | null) => {
          if (dayjs(value).format("YYYY-MM-DD") === "Invalid Date") {
            setFieldValue(`contracts.${index}.contractEndDate`, null);
            return;
          }
          setFieldValue(`contracts.${index}.contractEndDate`, dayjs(value).format("YYYY-MM-DD"));
        }}
        error={touched?.contracts?.[index]?.contractEndDate && Boolean(errors?.contracts?.[index]?.contractEndDate)}
        helperText={touched?.contracts?.[index]?.contractEndDate && errors?.contracts?.[index]?.contractEndDate}
      />
    </div>
  );
};

export default Company;
